export default __webpack_public_path__ + "static/WhatsApp-Logo-1ee748db55d428ce9e9dac6b3c20c2fa.png";